import type { WiwState } from '@/store';

export const getSending = (state: WiwState) => {
  return state.workchat.sending;
};
